import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BlogService } from '../../../core/services/blog.service';
import { BlogArticle } from '../../../core/models/blog.interface';
import { SeoService } from '../../../core/services/seo.service';

export const articleResolver: ResolveFn<BlogArticle | null> = (route, state) => {
  const blogService = inject(BlogService);
  const router = inject(Router);
  const seoService = inject(SeoService);
  
  const slug = route.paramMap.get('slug');

  if (!slug) {
    router.navigate(['/blog']);
    return of(null);
  }

  // Route pubblica: carica solo articoli pubblicati (nessuna preview qui)
  return blogService.getArticleBySlug(slug).pipe(
    tap((article) => {
      if (article) {
        seoService.setArticleMeta(article);
      }
    }),
    catchError((error) => {
      router.navigate(['/blog']);
      return of(null);
    })
  );
};

